import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import genres from "../constants/genres";
import GenreAcc from "./GenreAcc";

const AdminHome = () => {
    const navigate = useNavigate();

    const [regObject, setRegObject] = useState({});

    const getTotalReg = () => {
        Axios.get("https://ashish.moodi.org/competitions/get_total_reg")
            .then((res) => setRegObject(res.data))
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (localStorage.getItem("compiauthtoken")) {
            getTotalReg();
        } else {
            navigate("/admin/login");
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">
                <h2 className="col-sm-4">Select Competition to proceed</h2>
                {regObject.soloReg ? (
                    <h4 className="col-sm-2">Solo Reg: {regObject.soloReg}</h4>
                ) : (
                    <h4 class="placeholder-glow col-sm-2">
                        <span class="placeholder col-12"></span>
                    </h4>
                )}
                {regObject.teamReg ? (
                    <h4 className="col-sm-2">Team Reg: {regObject.teamReg}</h4>
                ) : (
                    <h4 class="placeholder-glow col-sm-2">
                        <span class="placeholder col-12"></span>
                    </h4>
                )}
                {regObject.totalReg ? (
                    <h4 className="col-sm-2">Team Reg: {regObject.totalReg}</h4>
                ) : (
                    <h4 class="placeholder-glow col-sm-2">
                        <span class="placeholder col-12"></span>
                    </h4>
                )}
                <a
                    className="btn btn-primary col-sm-1"
                    href="https://ashish.moodi.org/competitions/get_total_reg_csv"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Download Solo reg
                </a>
                <a
                    className="btn btn-primary col-sm-1"
                    href="https://ashish.moodi.org/competitions/get_total_team_csv"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Download Team reg
                </a>
            </div>

            <div class="accordion" id="accordionExample">
                {genres.map((genre) => {
                    return <GenreAcc genre={genre} />;
                })}
            </div>
        </div>
    );
};

export default AdminHome;
